module.exports = __webpack_public_path__ + "img/grid-desenfumage.fb759a96.jpg";